// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-cnd-btn {
  border: 1px solid #5084fd;
  background-color: #5084fd;
  color: #fff;
  padding: 3px 10px;
  display: flex;
  align-items: center;
  font-size: 12px;
}

.tag-cnd-btn:hover {
  background-color: #fff;
  color: #5084fd;
}

.cancel-tag-cnd-btn, .cancel-tag-cnd-btn:hover {
  border: 1px solid #cb0909;
  background-color: #cb0909;
  color: #fff;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./../candidate/src/pages/CandidateListing/CandidateTagging/CandidateTagging.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AACJ;;AAEA;EACI,sBAAA;EACA,cAAA;AACJ;;AAEA;EACI,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;AACJ","sourcesContent":[".tag-cnd-btn {\n    border: 1px solid rgb(80, 132, 253);\n    background-color: rgb(80, 132, 253);\n    color: #fff;\n    padding: 3px 10px;\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n}\n\n.tag-cnd-btn:hover {\n    background-color: #fff;\n    color: rgb(80, 132, 253);\n}\n\n.cancel-tag-cnd-btn, .cancel-tag-cnd-btn:hover {\n    border: 1px solid rgb(203, 9, 9);\n    background-color: rgb(203, 9, 9);\n    color: #fff;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
